
import React from "react";
import banner from "../../assets/images/trustworthy-about-banner.jpg";

const DataDeletion = () => {
  return (
    <>
      {/* Inner Banner */}
      <section className="inner-banner">
        <img
          src={banner}
          alt="Data Deletion Banner"
          className="inner-banner-img"
        />

        <div className="inner-banner-content">
          <div className="container">
            <div className="inner-banner-content-in">
              <h1>Data Deletion</h1>

              <p>
                Request deletion of your Sevasati account and personal data
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Data Deletion Content */}
      <section className="data-deletion py-5">
        <div className="container">
          <div className="row">
            <div className="col-md-12">

              <h1 className="mb-3 text-center fw-bold">
                Data Deletion 
              </h1>

              <p>
                <strong>Last Updated: 24 September 2026</strong>
              </p>

              <p>
                At <strong>Sevasati</strong>, we respect your privacy and give
                you control over your personal information. If you no longer
                wish to use the Sevasati Customer Application, Vendor
                Application, website, or related services, you may request
                deletion of your account and associated personal information.
              </p>

              {/* 1 */}
              <h2>1. Request Account Deletion</h2>

              <p>
                Customers and vendors can request deletion of their Sevasati
                account and personal information.
              </p>

              <p>
                An account deletion request may result in the removal or
                anonymization of information associated with your account,
                subject to applicable legal, security, financial, and business
                requirements.
              </p>

              {/* 2 */}
              <h2>2. How to Request Data Deletion</h2>

              <p>
                To request deletion of your Sevasati account and personal
                information, please contact us through the Contact Us section
                available on our official website or mobile application.
              </p>

              <p>
                When submitting a deletion request, please provide the mobile
                number or email address associated with your Sevasati account so
                that we can verify your identity and process the request.
              </p>

              <p>
                For security purposes, we may ask for additional information to
                verify that the request is being made by the actual account
                holder.
              </p>

              {/* 3 */}
              <h2>3. Customer Account Data</h2>

              <p>
                If you are a Sevasati customer, the deletion request may apply
                to personal information associated with your customer account,
                including:
              </p>

              <ul>
                <li>Name</li>
                <li>Mobile number</li>
                <li>Email address</li>
                <li>Profile information</li>
                <li>Profile photograph, where applicable</li>
                <li>Saved address information</li>
                <li>Location-related information associated with your account</li>
                <li>Referral information</li>
                <li>Account preferences</li>
              </ul>

              {/* 4 */}
              <h2>4. Service and Booking Information</h2>

              <p>
                Account deletion may affect information associated with your
                previous and current service bookings.
              </p>

              <p>
                Certain booking, transaction, service, complaint, or dispute
                information may be retained for a reasonable period where
                required for:
              </p>

              <ul>
                <li>Legal or regulatory compliance</li>
                <li>Financial and accounting records</li>
                <li>Fraud prevention</li>
                <li>Dispute resolution</li>
                <li>Security purposes</li>
                <li>Enforcement of applicable terms and conditions</li>
              </ul>

              {/* 5 */}
              <h2>5. Vendor Account Data</h2>

              <p>
                If you are a Sevasati vendor, your deletion request may apply
                to personal and account information associated with your vendor
                profile.
              </p>

              <p>This may include:</p>

              <ul>
                <li>Vendor profile information</li>
                <li>Mobile number</li>
                <li>Email address</li>
                <li>Profile information</li>
                <li>Service-related information</li>
                <li>Booking request information</li>
                <li>Commission-related information</li>
                <li>Payment report information</li>
              </ul>

              <p>
                Certain vendor records may need to be retained where required
                for legal, tax, accounting, financial, security, or dispute
                resolution purposes.
              </p>

              {/* 6 */}
              <h2>6. Payment Information</h2>

              <p>
                Sevasati may use third-party payment gateways to process
                payments.
              </p>

              <p>
                Sevasati generally does not control or store complete payment
                credentials such as debit card numbers, credit card numbers,
                banking passwords, or UPI PINs.
              </p>

              <p>
                Transaction records such as payment status, transaction
                reference, amount, and booking information may be retained when
                required for accounting, financial, legal, fraud prevention, or
                dispute resolution purposes.
              </p>

              {/* 7 */}
              <h2>7. Information That May Be Retained</h2>

              <p>
                Some information may not be immediately deleted if we are
                required or permitted by law to retain it.
              </p>

              <p>This may include:</p>

              <ul>
                <li>Transaction records</li>
                <li>Payment records</li>
                <li>Tax and accounting records</li>
                <li>Booking records required for dispute resolution</li>
                <li>Fraud prevention and security records</li>
                <li>Information required by applicable law</li>
              </ul>

              <p>
                Where retention is required, such information will be retained
                only for the period necessary for the applicable purpose.
              </p>

              {/* 8 */}
              <h2>8. Data Deletion and Anonymization</h2>

              <p>
                Depending on the type of information and applicable legal
                requirements, Sevasati may delete, anonymize, or de-identify
                information rather than permanently deleting every historical
                record.
              </p>

              <p>
                Anonymized information that can no longer reasonably be linked
                to an identifiable individual may be retained for analytics,
                reporting, security, or service improvement purposes.
              </p>

              {/* 9 */}
              <h2>9. Effect of Account Deletion</h2>

              <p>
                Once an account deletion request has been processed, you may no
                longer be able to access:
              </p>

              <ul>
                <li>Your Sevasati account</li>
                <li>Your profile</li>
                <li>Your saved information</li>
                <li>Your booking history through the account</li>
                <li>Your referral information</li>
                <li>Other account-specific features</li>
              </ul>

              <p>
                Deleting your account may also affect your ability to use
                certain Sevasati services in the future unless you create a new
                account, where permitted.
              </p>

              {/* 10 */}
              <h2>10. Pending Services and Transactions</h2>

              <p>
                If you have an active, pending, ongoing, or disputed service at
                the time you request account deletion, we may need to retain
                certain information until the service or related transaction
                has been completed or resolved.
              </p>

              <p>
                This is necessary to protect customers, vendors, and Sevasati
                and to maintain accurate service and transaction records.
              </p>

              {/* 11 */}
              <h2>11. Third-Party Services</h2>

              <p>
                Some information may have been processed by third-party service
                providers such as payment gateways, OTP/SMS providers, cloud
                service providers, notification providers, or other technology
                partners.
              </p>

              <p>
                Where applicable, deletion of information held by third parties
                may be subject to their respective privacy policies and data
                retention requirements.
              </p>

              {/* 12 */}
              <h2>12. Push Notifications</h2>

              <p>
                After account deletion, Sevasati will no longer use your deleted
                account for normal account-related push notifications.
              </p>

              <p>
                You can also manage notification permissions through your
                mobile device settings.
              </p>

              {/* 13 */}
              <h2>13. Location Data</h2>

              <p>
                If location information was collected as part of your Sevasati
                account or service usage, we will handle it according to our
                Privacy Policy and applicable data retention requirements.
              </p>

              <p>
                You can also disable location permissions through your device
                settings.
              </p>

              {/* 14 */}
              <h2>14. How Long Does Deletion Take?</h2>

              <p>
                We will review and process valid account deletion requests
                within a reasonable period after completing the necessary
                identity verification and reviewing any applicable legal,
                financial, security, or transaction-related retention
                requirements.
              </p>

              <p>
                The actual time required may vary depending on the information
                involved and whether any information is required to be retained
                under applicable law.
              </p>

              {/* 15 */}
              <h2>15. Cancellation of Deletion Request</h2>

              <p>
                If your account deletion request has not yet been completed,
                you may contact Sevasati as soon as possible to request
                cancellation of the deletion request.
              </p>

              <p>
                Once deletion or anonymization has been completed, the affected
                information may not be recoverable.
              </p>

              {/* 16 */}
              <h2>16. Contact Us for Data Deletion</h2>

              <p>
                If you want to delete your Sevasati account or request deletion
                of your personal information, please contact us through the
                Contact Us section available on our official website or mobile
                application.
              </p>

              <p>
                Please provide the following information when submitting your
                request:
              </p>

              <ul>
                <li>Registered mobile number</li>
                <li>Registered email address, if applicable</li>
                <li>Account type (Customer or Vendor)</li>
                <li>Reason for the deletion request, if applicable</li>
              </ul>

              <p>
                We may contact you to verify your identity before processing the
                request.
              </p>

              {/* 17 */}
              <h2>17. Privacy Policy</h2>

              <p>
                For additional information about how Sevasati collects, uses,
                stores, and protects personal information, please review our
                Privacy Policy.
              </p>

              {/* 18 */}
              <h2>18. Changes to This Data Deletion Policy</h2>

              <p>
                Sevasati may update this Data Deletion Policy from time to time
                to reflect changes in our services, technology, legal
                requirements, or business practices.
              </p>

              <p>
                Any updated version will be published on our website or
                application with the revised "Last Updated" date.
              </p>

              {/* 19 */}
              <h2>19. User Consent</h2>

              <p>
                By submitting a data deletion request, you confirm that the
                information provided by you is accurate and that you are
                authorized to request deletion of the relevant Sevasati
                account.
              </p>

              <p>
                <strong>Sevasati</strong>
              </p>

              <p>
                We are committed to handling your personal information
                responsibly and respecting your privacy and data deletion
                choices.
              </p>

            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default DataDeletion;
